import { HelperCore } from "@/common/dependencies";

class Store {
  cacheMap = new Map();

  constructor () {
    if(!HelperCore.IS_PROD){
      window._cacheStore = this;
    }
  }

  setData (key, value) {
    this.cacheMap.set(key, value);
  }
  getData (key) {
    return this.cacheMap.get(key);
  }
  removeData (key) {
    this.cacheMap.delete(key);
  }

  // 消耗时长
  costTime = "cost_time";
  setCostTime (messageId, value) {
    const id = `${this.costTime}_${messageId}`;
    this.setData(id, value);
    return id;
  }
  getCostTime (messageId) {
    return this.getData(`${this.costTime}_${messageId}`);
  }

  // 裂图
  errorResources = "error_resources";
  addErrorResource = (url) => {
    let list = this.getData(this.errorResources) || [];
    list = list.filter(item => item != url);
    list.push(url);
    this.setData(this.errorResources, list);
  }
  isErrorResource (url) {
    let list = this.getData(this.errorResources) || [];
    return list.some(item => item == url);
  }
}

const cacheStore = new Store();
export default cacheStore;